import React, { useEffect, useState } from "react";
import { useNavigate, Outlet } from "react-router-dom";

const Layout = () => {
  const navigate = useNavigate();
  const [link, setLink] = useState(false);
  const [fillHomeIconColor, setFillHomeIconColor] = useState(true);
  const [fillfrenIconColor, setFillFrenIconColor] = useState(false);
  const tg_info = JSON.parse(localStorage.getItem("tg_info"));

  useEffect(() => {
    const tgUserId = tg_info?.tgUserId;
    const botName = tg_info?.botName;
    const gameName = tg_info?.gameName;
    setLink(
      process.env.REACT_APP_SWEAT_WEB_URL +
        `/?tg_user_id=${encodeURIComponent(
          tgUserId
        )}&game_name=${gameName}&bot_name=${botName}`
    );
  }, [tg_info]);

  return (
    <>
      <Outlet style={{ paddingBottom: "20%" }} />
      <div className="layout">
        <div
          className="navBarElement"
          onClick={() => {
            setFillHomeIconColor((prev) => true);
            setFillFrenIconColor(false);
            navigate("/");
          }}>
          <img
            src={
              fillHomeIconColor
                ? "/image/homeFillIcon.png"
                : "/image/homeIcon.png"
            }
            alt="game"
            width="20px"
            height="20px"
          />
          <div className="navBarElementText">Home</div>
        </div>
        <div
          className="navBarElement"
          // style={{ pointerEvents: "none" }}
          onClick={() => window.open(link, "_blank")}>
          {/* <div className="comingSoon">Coming Soon</div> */}
          <img
            src={"/image/taskIcon.png"}
            alt="task"
            width="20px"
            height="20px"
            // style={{ opacity: 0.2 }}
          />
          <div
            className="navBarElementText"
            // style={{ opacity: 0.2 }}
          >
            Task
          </div>
        </div>
        <div
          className="navBarElement"
          onClick={() => {
            setFillFrenIconColor((prev) => true);
            setFillHomeIconColor(false);
            navigate("/frens");
          }}>
          <img
            src={
              fillfrenIconColor
                ? "/image/frensFillIcon.png"
                : "/image/frensIcon.png"
            }
            alt="frens"
            width="20px"
            height="20px"
          />
          <div className="navBarElementText">Frens</div>
        </div>
      </div>
    </>
  );
};

export default Layout;
